<template>
  <div class="upload-container">
    <div class="upload-area" id="uploadArea" ref="uploadArea" v-if="dragAndDropCapable">
      <font-awesome-icon icon="cloud-upload-alt" size="3x" class="upload-icon" /> Drag image to upload or <input class="choose-file" type="file" ref="inputUpload" @change="addFiles" />
    </div>
    <div id="uploadArea" v-else>
      <input type="file" id="file" name="file" />
    </div>
    <div class="">
    <div class="row mt-5" id="photos">
      <div v-for="(file, key) in existingFiles" class="col-lg-4 file-listing" :key="key">
        <div class="file-wrapper">
          <img class="preview img-fluid" :ref="'preview'+(parseInt(key, 10)+newFiles.length)" :src="`https://alabama-travel.s3.amazonaws.com/partners-uploads/badge/image/${badge._id}/${badge.image}`" />
          <div class="file-content">
            <a class="remove" @click="removeExistingFile(key)">Delete Image</a>
          </div>
        </div>
      </div>
      <div v-for="(file, key) in newFiles" class="col-lg-6 file-listing" :key="key">
        <div class="file-wrapper">
          <img class="preview img-fluid" :ref="'preview'+parseInt(key, 10)" />
          <div class="file-content">
            <a class="remove" @click="removeNewFile(key)">Delete Image</a>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      dragAndDropCapable: false,
      existingFiles: [],
      newFiles: [],
      isValid: true,
    };
  },
  props: {
    files: {
      type: Array,
    },
    type: {
      type: String,
      required: false,
    },
    badgeId: {
      type: String,
      required: false,
    },
  },
  watch: {
    files() {
      this.existingFiles = this.files;
    },
  },
  mounted() {
    const div = document.createElement('div');
    this.dragAndDropCapable = (('draggable' in div)
      || ('ondragstart' in div && 'ondrop' in div))
      && 'FormData' in window
      && 'FileReader' in window;
    if (this.dragAndDropCapable) {
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach((evt) => {
        if (this.$refs.uploadArea) {
          this.$refs.uploadArea.addEventListener(evt, (e) => {
            e.preventDefault();
            e.stopPropagation();
          }, false);
        }
      });
      if (this.$refs.uploadArea) {
        this.$refs.uploadArea.addEventListener('drop', (e) => {
          for (let i = 0; i < e.dataTransfer.files.length; i++) {
            this.newFiles.push(e.dataTransfer.files[i]);
          }
          this.getImagePreviews();
        });
      }
    }
  },
  methods: {
    validUpdate() {
      this.$emit('isNowValid', this.isValid);
    },
    addFiles() {
      const fileType = /\b(svg)\b/i;
      for (let i = 0; i < this.$refs.inputUpload.files.length; i++) {
        if (fileType.test(this.$refs.inputUpload.files[i].name)) {
          this.newFiles.push(this.$refs.inputUpload.files[i]);
          this.validUpdate();
        } else {
          this.$bvToast.toast('Please make sure the image you are uploading is a svg file',
            {
              title: 'Error',
              autoHideDelay: 5000,
              appendToast: true,
            });
        }
        this.getImagePreviews();
      }
    },
    getImagePreviews() {
      for (let i = 0; i < this.newFiles.length; i++) {
        if (/\.(svg)$/i.test(this.newFiles[i].name)) {
          const reader = new FileReader();

          reader.addEventListener('load', () => {
            this.$refs[`preview${parseInt(i, 10)}`][0].src = reader.result;
          }, false);

          reader.readAsDataURL(this.newFiles[i]);
        } else {
          this.$nextTick(() => {
            this.$refs[`preview${parseInt(i, 10)}`][0].src = '/images/file.svg';
          });
        }
      }
    },
    removeNewFile(key) {
      this.newFiles.splice(key, 1);
      this.getImagePreviews();
    },
    removeExistingFile(key) {
      this.existingFiles.splice(key, 1);
    },
    async uploadFiles(badgeId) {
      try {
        if (this.newFiles.length === 0) {
          return;
        }
        const promises = [];
        for (let i = 0; i < this.newFiles.length; i++) {
          promises.push(this.uploadFile(this.newFiles[i], badgeId));
        }
        const newFilesToReturn = await Promise.all(promises);
        this.$emit('updateFiles', this.existingFiles.concat(newFilesToReturn));
      } catch (err) {
        console.log(`ERROR IN UPLOAD files: ${JSON.stringify(err)}`);
      }
    },
    async uploadFile(uploadedFile, badgeId) {
      const fileObj = {
        badge_id: badgeId,
        image: uploadedFile.name,
        type: uploadedFile.type,
      };
      let response = null;
      response = await axios.post(`${process.env.VUE_APP_API_ROOT}/misc/getBadgeForUpload`, JSON.stringify(fileObj));

      try {
        // eslint-disable-next-line
        delete axios.defaults.headers.common['Authorization'];

        const options = {
          headers: {
            'Content-Type': uploadedFile.type,
          },
        };
        await axios.put(response.data.url, uploadedFile, options);

        // have to add back the authorization header
        axios.defaults.headers.common.Authorization = this.$store.state.auth.user.tokens.IdToken;

        return {
          imageName: uploadedFile.name,
        };
      } catch (err) {
        // eslint-disable-next-line no-console
        return {
          imageName: null,
        };
      }
    },
  },
};
</script>

<style scoped>
.bold-text {
  font-weight: bold;
}
.choose-file {
  margin: 30px 0px 0px 100px;
}
.upload-area {
  border: #4e97b2 dashed 1px;
  font-size: 14px;
  text-align: center;
  padding: 80px 0;
  margin-top: 0px;
}
.upload-container { min-height: 250px; }
.upload-icon {
  vertical-align: middle;
  margin-left:15px;
  margin-right:15px;
  color:white;
  stroke: black;
  stroke-width: .8rem;
}
::-webkit-file-upload-button {
    background-color:white;
}
.file-wrapper {
  -webkit-box-shadow: 1px 1px 5px 0px rgba(0,0,0,0.08);
box-shadow: 1px 1px 5px 0px rgba(0,0,0,0.08);
border-radius: var(--rounded-xl);
}
.file-wrapper:hover {
  -webkit-box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.18);
box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.18);
border-radius: var(--rounded-xl);
}
.file-wrapper img {
  border-radius: 10px 10px 0 0;
}
.file-content {
  margin:20px;
  font-size: 14px;
}
.file-content span {
  margin-top: 10px;
  display: block;
}
.featured {
  width:50%;
  display:inline-block;
  padding:20px 0;

}
a.remove {
  width:100%;
  text-align: right;
  display:inline-block;
  margin-bottom: 10px;
  color:#666;
}
textarea {
  margin-bottom: 5px;
}
</style>
